import { RouteView } from '@/layouts';

const storesRouter = {
  path: '/store',
  name: 'Store',
  redirect: '/store/list',
  component: RouteView,
  meta: {
    title: '门店管理',
    icon: 'iconstore',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'StoreList',
      component: () => import('@/views/stores/List'),
      meta: {
        title: '门店列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'add',
      name: 'StoreAdd',
      component: () => import('@/views/stores/Add'),
      meta: {
        title: '添加门店',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'StoreEditor',
      component: () => import('@/views/stores/Editor'),
      meta: {
        title: '门店编辑',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'StoreEditor',
      component: () => import('@/views/stores/Editor'),
      meta: {
        title: '门店编辑',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'detail',
      name: 'StoreDetail',
      component: () => import('@/views/stores/Detail'),
      meta: {
        title: '查看店员',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default storesRouter;
